import React, { Component } from 'react';
import { Col, Button, Row } from 'react-bootstrap';
import { TruckContactBox } from './TruckContactBox';

export class TruckSelectionPanel extends Component {

    getTruckFrom = () => {
      if (this.props.selectedTruck >= 0) {
        return this.props.truckList[this.props.selectedTruck].fromLocation;
      } else {
        return '';
      }
    }

    getTruckTo = () => {
      if (this.props.selectedTruck >= 0) {
        return this.props.truckList[this.props.selectedTruck].toLocation;
      } else {
        return '';
      }
    }

    getSelectdTruck = () => {
      if (this.props.selectedTruck >= 0) {
        return this.props.truckList[this.props.selectedTruck];
      } else {
        return null;
      }
    }



    render() {
        return(

                  <Row>
                    <Col lg={12}>
                    <form>
                        <select className="form-control m-b" name="account" onChange={this.props.onTruckSelect} >
                        <option value="-1">Select a truck</option>
                        {this.props.truckList.map((truck, index) => {
                            return <option key={index} value={index}>{truck.pilotName}</option>
                        })}
                        </select>
                    </form>
                    </Col>

                    <Col lg={12}>
                      <TruckContactBox truck={this.getSelectdTruck()} onOpenChatPanel={this.props.onOpenChatPanel} onOpenDriverPanel={this.props.onOpenDriverPanel}> </TruckContactBox>
                    </Col>

                    <Col lg={12}>
                    <span className="track-panel-start">
                         Current Route:
                    </span>
                    </Col>

                    <Col lg={6}>
                      <span className="track-panel-start">
                          <i className="fa fa-map-marker" aria-hidden="true"></i> From: <strong>{this.getTruckFrom()}</strong>
                      </span>
                    </Col>

                    <Col lg={6}>
                      <span className="track-panel-start">
                          <i className="fa fa-map-marker" aria-hidden="true"></i> To: <strong>{this.getTruckTo()}</strong>
                      </span>
                    </Col>

                    <Col lg={12}>
                       <Button type="button" className="btn full-width btn-outline btn-danger btn-sm">Save WorkList</Button>
                    </Col>


                  </Row>

            );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/TruckSelectionPanel.js